import { getCookie } from "../../helpers";

export async function getUserFromCookie() {
  const userFromCookie = JSON.parse(decodeURIComponent(getCookie('user')));
  if (!userFromCookie) return;
  const user = { logged: true, data: userFromCookie };
  await this.setState({ user });
}

export function logout() {
  if (this.props.navigate) {
    this.props.navigate('/signout');
  }
}
